module.exports = __webpack_public_path__ + "static/media/icon-line-alcohol.ce1a2059.svg";